import {Component} from 'react';
import {doubleToStringMonthly, standardNumberFormat} from '../../../objects/CommonUse/double_functions';

class investmentBuySellConfirmCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false, 
            selected: false
        };
    }
   
    render() {

    return <>
        <tr className="">
            <td className={this.firstColumnClass}>{this.props.tableInfo.investmentName}</td>
            <td className="text-right p-0">{standardNumberFormat(this.props.tableInfo.quantity)}</td>
            <td className="text-right p-0">{doubleToStringMonthly(this.props.tableInfo.unitPrice)}</td>
            {this.props.couponSw ?
                <td className="text-right p-0">{doubleToStringMonthly(this.props.tableInfo.totalCouponAmt)}</td>
            :
                null    
            }
            <td className="text-right p-0">{doubleToStringMonthly(this.props.tableInfo.totalAmount)}</td>
        </tr>

    </>
    }
}

export default investmentBuySellConfirmCard;